import React from 'react'
import PropTypes from 'prop-types'
import InfoCardsItem from './InfoCardsItem'
import './InfoCards.scss'

const InfoCards = ({ data }) => {
  if (!data.visible) return null
  return (
    <div className="container my-3 my-md-5 info-cards">
      {data.title &&
        <h2 className="text-center pb-2 info-cards_title">{data.title}</h2>
      }
      <section className="row justify-content-center">
        {data.cards.map((cardData) => (
          <InfoCardsItem key={cardData.id} innerData={cardData} />
        ))}
      </section>
    </div>
  )
}

InfoCards.propTypes = {
  data: PropTypes.object.isRequired
}

export default InfoCards
